import React from "react";
import { Reveal, Overline } from "./Reveal";
import { GLOBAL_ROOM_IMG, CITY_ROOM_IMG } from "@/data/content";
import { Check } from "lucide-react";

const ROOMS = [
  {
    name: "Global Room",
    img: GLOBAL_ROOM_IMG,
    tagline: "Chic, modern & expansive",
    features: ["Largest room — up to 750 guests", "Prep kitchen + catering staging", "Flexible stage layouts", "Audio, video & sound features"],
    cta: "Book Global Room",
    reverse: false,
  },
  {
    name: "City Room",
    img: CITY_ROOM_IMG,
    tagline: "Elegant & intimate setting",
    features: ["Accommodates up to 500 guests", "Booth seating available", "Premium bar options", "Upscale lighting & flexible layouts"],
    cta: "Book City Room",
    reverse: true,
  },
];

export function VenueSpaces() {
  const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  return (
    <section id="venue-spaces" data-testid="venue-spaces-section" className="py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <Reveal className="text-center max-w-2xl mx-auto mb-16">
          <Overline>The Spaces</Overline>
          <h2 className="font-display text-4xl md:text-6xl text-white leading-none mt-4">Two Rooms. Endless Possibilities.</h2>
        </Reveal>

        <div className="space-y-16 md:space-y-24">
          {ROOMS.map((room, i) => (
            <Reveal key={room.name}>
              <div className={`grid lg:grid-cols-2 gap-10 lg:gap-16 items-center ${room.reverse ? "lg:[&>*:first-child]:order-2" : ""}`}>
                <div className="group overflow-hidden">
                  <img
                    src={room.img}
                    alt={room.name}
                    className="w-full aspect-[4/3] object-cover transition-transform duration-1000 group-hover:scale-105"
                  />
                </div>
                <div>
                  <Overline>{room.tagline}</Overline>
                  <h3 className="font-display text-4xl md:text-5xl text-white mt-3">{room.name}</h3>
                  <ul className="mt-7 space-y-3">
                    {room.features.map((f) => (
                      <li key={f} className="flex items-start gap-3 text-epic-gray">
                        <Check size={18} className="text-epic-gold mt-1 shrink-0" />
                        <span className="font-light">{f}</span>
                      </li>
                    ))}
                  </ul>
                  <button
                    data-testid={`venue-cta-${i}`}
                    onClick={() => go("booking")}
                    className="mt-8 bg-epic-gold text-epic-black font-bold uppercase tracking-widest text-sm px-8 py-4 hover:bg-epic-goldhover transition-colors duration-300"
                  >
                    {room.cta}
                  </button>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
